<script lang="ts">
import { defineComponent, PropType } from 'vue'
import { User, UserLite } from '../../../libs/models'
import illustUrl from '../libs/illustUrl'
import { useProfileModal } from '../libs/util'
export default defineComponent({
  emits: ['click'],
  props: {
    user: { required: true, type: Object as PropType<User | UserLite> },
    emit: { default: false, type: Boolean }
  },
  setup (props, { emit }) {
    const { open: openProfileModal } = useProfileModal()
    const onClick = () => {
      if (props.emit) return emit('click')
      openProfileModal(props.user)
    }
    return {
      onClick,
      illustUrl
    }
  }
})
</script>

<template>
  <span @click.stop class="userNameWrapper">
    <span class="UserName" @click="onClick">
      <div class="UserName-image" v-if="user.illust_id">
        <img :src="illustUrl(user.id, user.illust_id)">
      </div>
      <div class="UserName-name">{{ user.name }}</div>
    </span>
  </span>
</template>

<style lang="scss" scoped>
.userNameWrapper {
  line-height: 0;
}
.UserName {
  display: inline-flex;
  align-items: center;
  cursor: pointer;
  &-image {
    width: 1.8em;
    height: 1.8em;
    margin-right: 4px;
    background: rgba(255, 255, 255, 0.5);
    overflow: hidden;
    border-radius: 20px;
    img {
      display: block;
      object-fit: cover;
      max-width: none;
      width: 100%;
      height: 100%;
    }
  }
  &-name {
    user-select: text;
    font-weight: bold;
    color: var(--green);
    text-decoration: underline;
    line-height: 1;
  }
}
</style>
